﻿/* 
Object:         Inputs
Description:    Logic for inputs who are 
Used in:        Forms or pages where html inputs are available.
*/

window.inputs = function () {

    var titleDialogUnSavedChanges = "Unsaved changes";
    var contentDialogUnSavedChanges = "Continou while having unsaved changes";

    return {

        /**
         * Navigate to a specific url (used in all modules to navigate -> edit)
         * @param {string} title
         * @param {string} content
         */
        initialize: function (title, content) {
            titleDialogUnSavedChanges = title;
            contentDialogUnSavedChanges = content;

            // Select all different inputs
            const inputs = $('form :input, select, :checkbox');
            const forms = $('form');

            // Inputs foreach 
            inputs.each(function () {
                var valueDataValReq = $(this).attr("data-val-required");    // Get the data value required 
                var valueType = $(this).attr("type");                       // Get the type

                if (valueType == "checkbox") {
                    if ($(this)[0].disabled && $(this)[0].checked) {
                        // set same value to hidden field: <input name="Enable" type="hidden" value="false" >
                        var cbName = $(this)[0].name;
                        var cbValue = $(this)[0].checked;
                        $('form :input:hidden[name="' + cbName + '"]').val(cbValue);
                    }
                }

                // The dataValueRequered attribute must not be undefined and the input is not hidden (for id's that are send with the post request).
                if (valueDataValReq !== undefined && valueType !== "hidden" && valueType !== "checkbox") {
                    var parentElement = $(this).parent();
                    parentElement.addClass("precom-requiredInput");
                }

                // This is general for all the text inputs. 
                $(this).on('input', function () {

                    var parentElement = $(this).parent();

                    if (this.defaultValue !== this.value) {
                        parentElement.addClass("precom-dirtyInput");
                    } else {
                        parentElement.removeClass("precom-dirtyInput");
                    }
                });

                // This is specific for all the combobox/listbox inputs  
                $(this).on('change', function () {

                    var parentElement = $(this).parent();

                    if (this.defaultValue !== this.value) {
                        parentElement.addClass("precom-dirtyInput");
                    } else {
                        parentElement.removeClass("precom-dirtyInput");
                    }
                });
            });
        },

        /**
         * Navigate to a specific url (used in all modules to navigate -> edit)
         */
        removeDirtyInput: function () {
            $('*').removeClass('precom-dirtyInput'); // remove all the precom-dirty inputs ... 
        },

        /**
         * Navigate to a specific url (used in all modules to navigate -> edit)
         * @param {object} event
         * @param {string} yesActionCallback
         */
        checkDirtyInput: function (event, yesActionCallback) {
            if ($('.precom-dirtyInput [id!="Loginname"][type!=password]').length) {
                if (event != null) {
                    event.preventDefault();
                }
                dialog.createDialogWithCustomTitleAndMessage(titleDialogUnSavedChanges, contentDialogUnSavedChanges, yesActionCallback, function () { });
            } else {
                yesActionCallback(); // When there are no changes, call the callback instantaniously
            }
        }
    }

}();